const space = ' ';
const operators = [':', '=', '>', '<'];
const lastIndexTokens = operators.concat(space);
function getLastChar(x) {
    return x[x.length - 1];
}
function isLastCharSpace(x) {
    return getLastChar(x) === space;
}
function isLengthOne(x) {
    return x.length === 1;
}
function isLastCharOperator(x) {
    return operators.includes(getLastChar(x));
}
function getIndexOfLastToken(x) {
    let counter = 0;
    let found = false;
    for (let i = x.length - 1; i > 0; i--) {
        const c = x[i];
        if (lastIndexTokens.includes(c)) {
            found = true;
            break;
        }
        counter++;
    }
    if (found) {
        return x.length - counter;
    }
    return 0;
}
export function concatenateQuery(query, field) {
    if (field.length === 0) {
        return query;
    }
    if (query.length === 0) {
        return field;
    }
    if (isLastCharSpace(query) || isLengthOne(field) || isLastCharOperator(query)) {
        return query + field;
    }
    if (query.endsWith(field)) {
        return `${query} `;
    }
    const index = getIndexOfLastToken(query);
    if (index > 0) {
        return query.substring(0, index) + field;
    }
    const s = query.split(' ');
    s.pop();
    s.push(field);
    return s.join(' ');
}
